import React from 'react';
import { QuoteIcon } from 'lucide-react';
import type { Voice } from '../data/testimonials';
type TestimonialsProps = {
  voices: Voice[];
  title?: string;
  background?: 'white' | 'panel';
};

/**
 * "Tech to tech": frases reales de técnicos, dueños de sistema e industria en
 * foros y publicaciones públicas (VOC de la ficha), con fuente. No se
 * presentan como reseñas del producto.
 */
export function Testimonials({
  voices,
  title = 'Sound familiar?',
  background = 'white'
}: TestimonialsProps) {
  if (voices.length === 0) return null;
  const bg = background === 'white' ? 'bg-white' : 'bg-paper-dark';
  return <section aria-label={title} className={`w-full text-pine ${bg}`} data-id="element-373" data-mp="2x1l0uvg9gtya">
      <div className="mx-auto max-w-6xl px-5 py-14 sm:py-20" data-id="element-374" data-mp="2s28ba2y098s0">
        <div className="text-center" data-id="element-375" data-mp="2s4303scedl1d">
          <p className="eyebrow text-ember-deep" data-id="element-376" data-mp="v9opblu3fk3i">Tech to tech</p>
          <h2 className="trail-underline mt-3 font-display text-[34px] leading-tight text-pine sm:text-6xl" data-id="element-377" data-mp="v72hrm77d4la">
            {title}
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-[15px] text-pine-soft" data-id="element-378" data-mp="h4wvo4o4mgj9">
            Real words from technicians, system owners and the industry in
            public forums. This is exactly the call Solar PV &amp; Battery
            Diagnostic Pro was built for.
          </p>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-379" data-mp="c625ghntxpp4">
          {voices.map(item => <figure key={item.quote} className="trail-card rounded-2xl border border-paper-dark bg-paper p-6" data-id="element-380" data-mp="zxhc2mmn2t66">
              <QuoteIcon className="h-7 w-7 text-ember" aria-hidden="true" data-id="element-381" data-mp="q6mmp9e3jdgi" />
              <blockquote className="field-note mt-2 text-[28px] leading-[1.1] text-pine" data-id="element-382" data-mp="q4jy8tsldsdw">
                “{item.quote}”
              </blockquote>
              <figcaption className="mt-4 text-xs text-pine-soft" data-id="element-383" data-mp="1iv1yzo5ufho5">
                <span className="block text-[13px] font-bold text-pine" data-id="element-384" data-mp="1ith6s5704atg">
                  {item.author}
                </span>
                {item.source}
              </figcaption>
            </figure>)}
        </div>

        <p className="mt-6 text-center text-[11px] text-pine-muted" data-id="element-385" data-mp="1sio2ev23eyyp">
          Quoted as written from public forums and industry publications. Not
          reviews of this product.
        </p>
      </div>
    </section>;
}